export default {"src":"/_next/static/media/enerflo-platform-icon-logically-priced.72d81fc1.svg","height":160,"width":160};